import { formatText } from 'core/i18n';
import {
    COUNTRY_CODE_ES,
    COUNTRY_CODE_PT,
    COUNTRY_CODE_NL,
    COUNTRY_CODE_DE,
    COUNTRY_PREFIX_ES,
    COUNTRY_PREFIX_PT,
    COUNTRY_PREFIX_NL,
    COUNTRY_PREFIX_DE,
    COUNTRY_CODE_EN,
    COUNTRY_DOCUMENT_TYPE_DNI,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_TREATMENT_DEFAULT,
    COUNTRY_TREATMENT_DR,
    COUNTRY_TREATMENT_PROF,
    COUNTRY_TREATMENT_PROFDR,
    COUNTRY_DOCUMENT_TYPE_DA,
    COUNTRY_DOCUMENT_TYPE_PA,
    COUNTRY_DOCUMENT_TYPE_CC,
    COUNTRY_DOCUMENT_TYPE_PP,
    COUNTRY_DOCUMENT_TYPE_DN,
    COUNTRY_DOCUMENT_TYPE_PN,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
} from 'constants/multiLanguage';

export const isCountrySpain = () => window.__COUNTRY__ === COUNTRY_CODE_ES;
export const isCountryPortugal = () => window.__COUNTRY__ === COUNTRY_CODE_PT;
export const isCountryGermany = () => window.__COUNTRY__ === COUNTRY_CODE_DE;
export const isCountryNetherlands = () => window.__COUNTRY__ === COUNTRY_CODE_NL;

export const getReferenceCodeByCountry = () => {
    if (isCountrySpain()) return COUNTRY_CODE_ES;
    if (isCountryPortugal()) return COUNTRY_CODE_PT;
    if (isCountryNetherlands()) return COUNTRY_CODE_NL;
    if (isCountryGermany()) return COUNTRY_CODE_DE;

    return COUNTRY_CODE_ES;
};

export const getReferencePrefixByCountry = () => {
    if (isCountrySpain()) return COUNTRY_PREFIX_ES;
    if (isCountryPortugal()) return COUNTRY_PREFIX_PT;
    if (isCountryNetherlands()) return COUNTRY_PREFIX_NL;
    if (isCountryGermany()) return COUNTRY_PREFIX_DE;

    return COUNTRY_PREFIX_ES;
};

export const getReferenceLanguageByCountry = () => {
    if (isCountrySpain()) return { primary: COUNTRY_CODE_ES, secundary: COUNTRY_CODE_EN };
    if (isCountryPortugal() === true) return { primary: COUNTRY_CODE_PT, secundary: COUNTRY_CODE_ES };
    if (isCountryNetherlands() === true) return { primary: COUNTRY_CODE_NL, secundary: COUNTRY_CODE_ES };
    if (isCountryGermany() === true) return { primary: COUNTRY_CODE_DE, secundary: COUNTRY_CODE_ES };

    return { primary: COUNTRY_CODE_ES, secundary: COUNTRY_CODE_EN };
};

export const getReferenceOptionsDocumentTypeByCountry = () => {
    if (isCountrySpain()) {
        return [
            { label: formatText('doctype-dni'), value: COUNTRY_DOCUMENT_TYPE_DNI },
            { label: formatText('doctype-nie'), value: COUNTRY_DOCUMENT_TYPE_NIE },
        ];
    }
    if (isCountryPortugal()) {
        return [
            { label: formatText('doctype-cc'), value: COUNTRY_DOCUMENT_TYPE_CC },
            { label: formatText('doctype-pp'), value: COUNTRY_DOCUMENT_TYPE_PP },
        ];
    }
    if (isCountryNetherlands()) {
        return [
            { label: formatText('doctype-pn'), value: COUNTRY_DOCUMENT_TYPE_PN },
            { label: formatText('doctype-dn'), value: COUNTRY_DOCUMENT_TYPE_DN },
        ];
    }
    if (isCountryGermany()) {
        return [
            { label: formatText('doctype-da'), value: COUNTRY_DOCUMENT_TYPE_DA },
            { label: formatText('doctype-pa'), value: COUNTRY_DOCUMENT_TYPE_PA },
        ];
    }

    return [
        { label: formatText('doctype-dni'), value: COUNTRY_DOCUMENT_TYPE_DNI },
        { label: formatText('doctype-nie'), value: COUNTRY_DOCUMENT_TYPE_NIE },
    ];
};

export const getReferenceOptionsTreatmentByCountry = () => {
    if (isCountryGermany()) {
        return [
            { label: formatText('treatment-default'), value: COUNTRY_TREATMENT_DEFAULT },
            { label: formatText('treatment-dr'), value: COUNTRY_TREATMENT_DR },
            { label: formatText('treatment-prof'), value: COUNTRY_TREATMENT_PROF },
            { label: formatText('treatment-profdr'), value: COUNTRY_TREATMENT_PROFDR },
        ];
    }

    return [{ label: formatText('treatment-default'), value: COUNTRY_TREATMENT_DEFAULT }];
};

export const getReferenceTooltipDocumentTypeByCountry = () => {
    if (isCountrySpain()) return 'initial-document';
    if (isCountryPortugal()) return 'initial-document_pt';
    if (isCountryNetherlands()) return 'initial-document_nl';
    if (isCountryGermany()) return 'initial-document_de';

    return 'initial-document';
};

export const getMainDocumentTypeByCountry = () => {
    if (isCountrySpain()) {
        return COUNTRY_DOCUMENT_TYPE_DNI;
    }
    if (isCountryPortugal()) {
        return COUNTRY_DOCUMENT_TYPE_CC;
    }
    if (isCountryNetherlands()) {
        return COUNTRY_DOCUMENT_TYPE_DN;
    }
    if (isCountryGermany()) {
        return COUNTRY_DOCUMENT_TYPE_DA;
    }

    return COUNTRY_DOCUMENT_TYPE_DNI;
};

export const getSecondaryDocumentTypeByCountry = () => {
    if (isCountrySpain()) {
        return COUNTRY_DOCUMENT_TYPE_NIE;
    }
    if (isCountryPortugal()) {
        return COUNTRY_DOCUMENT_TYPE_PP;
    }
    if (isCountryNetherlands()) {
        return COUNTRY_DOCUMENT_TYPE_PN;
    }
    if (isCountryGermany()) {
        return COUNTRY_DOCUMENT_TYPE_PA;
    }

    return COUNTRY_DOCUMENT_TYPE_NIE;
};

export const getAliasesDocumentType = documentType => {
    const reference = {};
    reference[COUNTRY_DOCUMENT_TYPE_DNI] = COUNTRY_DOCUMENT_TYPE_DNI_LABEL;
    reference[COUNTRY_DOCUMENT_TYPE_NIE] = COUNTRY_DOCUMENT_TYPE_NIE_LABEL;

    if (reference[documentType]) return reference[documentType];

    return documentType;
};

export const getNameCountryByCountry = () => {
    if (isCountrySpain()) return 'passport-country_es';
    if (isCountryPortugal()) return 'passport-country_pt';
    if (isCountryNetherlands()) return 'passport-country_nl';
    if (isCountryGermany()) return 'passport-country_de';

    return 'initial-document';
};

export const getTimeInformationClient = () => {
    if (isCountryPortugal()) return 'initial-contactMessage_pt';
    if (isCountryNetherlands()) return 'initial-contactMessage_nl';
    if (isCountryGermany()) return 'initial-contactMessage_de';

    return 'initial-contactMessage_es';
};

export const setTitleDocument = () => {
    let title = 'Openbank | Hazte Cliente';
    if (isCountryGermany()) title = 'Openbank | Kunde Werden';
    else if (isCountryNetherlands()) title = 'Openbank | Klant Worden';
    else if (isCountryPortugal()) title = 'Openbank | Abrir Conta';

    document.title = title;
};

export const generatePublicUrl = (publicUrl, language) => {
    let publicUrlOutput = publicUrl;
    if (isCountrySpain() && COUNTRY_CODE_ES !== language) publicUrlOutput += `${language}`;
    else if (isCountryPortugal() && COUNTRY_CODE_PT !== language) publicUrlOutput += `${language}`;
    else if (isCountryNetherlands() && COUNTRY_CODE_NL !== language) publicUrlOutput += `${language}`;
    else if (isCountryGermany() && COUNTRY_CODE_DE !== language) publicUrlOutput += `${language}`;

    return publicUrlOutput;
};

export const removeLanguageFromPublicUrl = publicUrl => {
    return publicUrl?.replace(/\/[a-z]{2}$/, '/');
};

export const setPlaceHolderDocTypeByCountry = doctype => {
    if (getSecondaryDocumentTypeByCountry() === doctype) {
        return 'placeholder-documentOpcion2';
    }

    return 'placeholder-document';
};

export const disableNationalityByCountry = docType => {
    const mainDocType = getMainDocumentTypeByCountry();

    return docType === mainDocType || (docType === getAliasesDocumentType(mainDocType) && isCountrySpain());
};
